<template>
  <div class="action-dispatcher">
    <template v-if="isLoading">
      <slot name="skeleton">
        <div
          class="d-flex justify-content-center p-3 py-5"
          :class="loadingClass"
        >
          <div class="spinner-border text-primary"></div>
        </div>
      </slot>
    </template>

    <div class="error p-4 pt-5 text-center" v-else-if="isError">
      <div class="pt-lg-5"></div>
      Erro!
      <button class="btn-link link" @click="dispatch">Tentar novamente</button>
    </div>
    <slot v-else v-bind:data="data" />
  </div>
</template>

<script setup>
  import { watch } from "vue";
  import { useQuery } from "vue-query";
  import { useStore } from "vuex";

  const props = defineProps(["action", "parameters", "loadingClass"]);
  const emit = defineEmits(["success", "error"]);
  const store = useStore();

  function useDispatchQuery() {
    return useQuery(
      [`${props.action}-${JSON.stringify(props?.parameters || "")}`],
      () => store.dispatch(props.action, props.parameters)
    );
  }

  const { isSuccess, isLoading, isError, data, error } = useDispatchQuery();

  watch(isSuccess, (v) => {
    if (v) emit("success", data.value);
  });

  watch(isError, (v) => {
    if (v) emit("error", error);
  });
</script>

<style lang="scss" scoped>
  .action-dispatcher {
    .error {
      .link {
        padding: 0;
        border: none;
        background: transparent;
      }
    }
  }
</style>
